import React from 'react';
import PropTypes from 'prop-types';
import CommentItem from './commentItem';
import CommentForm from './commentForm';

const CommentsList = (props) => {
  const listItems = props.comments.map(comment => {
    return <CommentItem key={comment.id} comment={comment} />;
  });

  return (
    <ol>
      {listItems}
      <li>
        {props.commentStatus === 'loading' ? 
          <span>Submitting...</span> :
          <CommentForm onCommentFormSubmitted={props.onCommentFormSubmitted} />}
      </li>
    </ol>
  );
}

CommentsList.propTypes = {
  comments: PropTypes.array.isRequired,
  onCommentFormSubmitted: PropTypes.func.isRequired,
  commentStatus: PropTypes.string
};

export default CommentsList;


// WEBPACK FOOTER //
// ./src/views/commentsList.js